import React from 'react';
import Styles from './styles.module.css';
import Loader from '../../assets/svg/loader.svg';

const ProfileList = ({ 
    profiles, 
    isLoading, 
    onEdit, 
    onDelete, 
    onCopy,
    getImportTypeDisplay,
    salesChannels = [],
    shippingMethods = []
}) => {
    const formatDate = (dateString) => {
        if (!dateString) return 'Unbekannt';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return 'Ungültiges Datum';
            return date.toLocaleDateString('de-DE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        } catch (error) {
            return 'Ungültiges Datum';
        }
    };

    const getSalesChannelName = (salesChannelId) => {
        if (!salesChannelId) return 'Standard';
        if (salesChannels.length === 0) return 'Wird geladen...';
        const salesChannel = salesChannels.find(sc => sc.id === salesChannelId);
        return salesChannel ? salesChannel.name : `ID: ${salesChannelId.substring(0, 8)}...`;
    };

    const getShippingMethodName = (shippingMethodId) => {
        if (!shippingMethodId) return 'Standard';
        if (shippingMethods.length === 0) return 'Wird geladen...';
        const shippingMethod = shippingMethods.find(sm => sm.id === shippingMethodId);
        return shippingMethod ? shippingMethod.name : `ID: ${shippingMethodId.substring(0, 8)}...`;
    };

    const getPriceHandling = (profile) => {
        // Check the withPrices setting for all import types
        const withPrices = profile.defaultValues?.withPrices === true;
        return withPrices ? 'System-Preise' : 'Null-Preise (0 €)';
    };

    if (isLoading) {
        return (
            <div className={Styles.loading}>
                <img src={Loader} width={40} height={40} alt="Loading" />
                <span>Lade Profile...</span>
            </div>
        );
    }

    return (
        <div className={Styles.container}>
            <div className={Styles.profileGrid}>
                <div className={Styles.gridHeader}>
                    <span>Name</span>
                    <span>Import-Typ</span>
                    <span>Verkaufskanal</span>
                    <span>Erstellt</span>
                    <span>Aktionen</span>
                </div>

                {profiles.map((profile) => (
                    <div key={profile.id} className={Styles.gridRow}>
                        <div className={Styles.profileName}>
                            <strong>{profile.name}</strong>
                            {profile.description && (
                                <p className={Styles.description}>
                                    {profile.description}
                                </p>
                            )}
                        </div>

                        <div className={Styles.importType}>
                            <span className={Styles.typeLabel}>
                                {getImportTypeDisplay(profile)}
                            </span>
                            <span className={Styles.subLabel}>
                                {getPriceHandling(profile)}
                            </span>
                        </div>

                        <div className={Styles.salesChannel}>
                            <span className={Styles.typeLabel}>
                                {getSalesChannelName(profile.defaultValues?.salesChannelId)}
                            </span>
                            <span className={Styles.subLabel}>
                                {getShippingMethodName(profile.defaultValues?.shippingMethodId)}
                            </span>
                        </div>

                        <div className={Styles.createdDate}>
                            {formatDate(profile.createdAt)}
                        </div>

                        <div className={Styles.actions}>
                            <button
                                className={`${Styles.actionButton} ${Styles.editButton}`}
                                onClick={() => onEdit(profile)}
                                title="Profil bearbeiten"
                            >
                                ✏️
                            </button>
                            <button
                                className={`${Styles.actionButton} ${Styles.copyButton}`}
                                onClick={() => onCopy(profile)}
                                title="Profil kopieren"
                            >
                                📋
                            </button>
                            <button
                                className={`${Styles.actionButton} ${Styles.deleteButton}`}
                                onClick={() => onDelete(profile.id)}
                                title="Profil löschen"
                            >
                                🗑️
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {profiles.length === 0 && (
                <div className={Styles.noProfiles}>
                    <p>Keine Profile gefunden.</p>
                </div>
            )}
        </div>
    );
};

export default ProfileList;